import React, { useState, useEffect } from 'react';
import { queryClient } from 'src/lib/queryClient';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { Button, Card, Input, Label } from '../../shared/components/Form';
import { login } from './api';

import { useAuth } from './AuthContext';

function getRoleHome(m: any) {
    if (m?.mustChangePassword) return '/change-password';
    return m?.isServiceAdmin ? '/admin' : m?.isCompanyAdmin ? '/company' : '/projects';
}

export default function LoginPage() {
    const nav = useNavigate();
    const loc = useLocation();
    const { me, reload } = useAuth();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [err, setErr] = useState<string | null>(null);

    // const redirect = new URLSearchParams(loc.search).get('redirect') || '/projects';
    // 리다이렉트 쿼리가 있으면 그걸 우선으로 하고, 없으면 역할별 홈으로
    const redirectParam = new URLSearchParams(loc.search).get('redirect');
    const wasLoggedOut = new URLSearchParams(loc.search).get('logged_out') === '1';
    // 로그인 상태면 로그인 페이지에 머무르지 않도록 즉시 이동
    // useEffect(() => {
    //     if (me) nav(redirect, { replace: true });
    // }, [me, redirect, nav]);
    useEffect(() => {
        if (me) {
            nav(
                me.mustChangePassword
                    ? `/change-password${redirectParam ? `?redirect=${encodeURIComponent(redirectParam)}` : ''}`
                    : !wasLoggedOut && redirectParam
                      ? redirectParam
                      : getRoleHome(me),
                { replace: true },
            );
        }
    }, [me, nav, redirectParam, wasLoggedOut]);


    async function onSubmit(e: React.FormEvent) {
        e.preventDefault();
        setErr(null);
        try {
            await login({ email, password });
            queryClient.clear();
            await reload(); // 토큰 저장 후 컨텍스트 새로고침
        } catch (e: any) {
            const serverMsg = e?.response?.data?.error?.message ?? e?.response?.data?.message ?? e?.message;
            setErr(serverMsg || '로그인 실패');
        }
    }

    return (
        <div className="min-h-screen grid place-items-center bg-gradient-to-b from-orange-50 to-sky-50">
            <Card>
                <h1 className="text-xl font-semibold mb-4">로그인</h1>
                <form onSubmit={onSubmit} className="space-y-4 w-80">
                    <div>
                        <Label>이메일</Label>
                        <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" />
                    </div>
                    <div>
                        <Label>비밀번호</Label>
                        <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" />
                    </div>
                    {err && <div className="text-sm text-red-600">{err}</div>}
                    <Button type="submit">로그인</Button>
                </form>
                <div className="mt-4 text-sm text-gray-600">
                    계정이 없으신가요?{' '}
                    <Link className="text-sky-700 underline" to="/register">
                        회원가입
                    </Link>
                </div>
            </Card>
        </div>
    );
}
